<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList } from "@unio/saltbox-ui"
import { ref } from "vue"

import EmptyState from "@/components/EmptyState.vue"
import IndexHeader from "@/components/IndexHeader.vue"
import NarrowPage from "@/components/NarrowPage.vue"
import PersonFormSlideover from "@/components/PersonFormSlideover.vue"
import PersonListItem from "@/components/PersonListItem.vue"
import SearchInput from "@/components/SearchInput.vue"
import { useNavbar } from "@/composables/useNavbar"
import { useSearchableIndex } from "@/composables/useSearchableIndex"
import { ICON } from "@/lib/icons"
import { peoplePath } from "@/routes"
import type { PersonSummary } from "@/types/models"

const { title } = useNavbar({ title: "People" })

interface Props {
  people: PersonSummary[]
  query: string
}

const props = defineProps<Props>()

const { search } = useSearchableIndex(props.query, peoplePath)
const slideoverOpen = ref(false)
</script>

<template>
  <Head :title="title" />

  <NarrowPage>
    <IndexHeader
      :count="people.length"
      noun="person"
      plural-noun="people"
      button-label="New Person"
      @action="slideoverOpen = true"
    />

    <SearchInput v-model="search" placeholder="Search people..." />

    <SbList v-if="people.length" bordered separator>
      <PersonListItem v-for="person in people" :key="person.id" :person="person" />
    </SbList>

    <EmptyState v-else :icon="ICON.people" noun="people" :query="query" />
  </NarrowPage>

  <PersonFormSlideover v-model:open="slideoverOpen" :person="null" />
</template>
